<template>
    <a-page-header :title="title" :style="{ padding: 0 }" :sub-title="memo" @back="() => $router.go(-1)">
        <template slot="extra">
            <a-breadcrumb>
                <a-breadcrumb-item :style="{ color: '#000' }">
                    <a-icon type="appstore" />
                    心理云平台
                </a-breadcrumb-item>
                <a-breadcrumb-item v-for="item in breadcrumb" :key="item">{{ item }}</a-breadcrumb-item>
            </a-breadcrumb>
        </template>
    </a-page-header>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        memo: {
            type: String,
            required: true
        }
    },
    computed: {
        breadcrumb() {
            return JSON.parse(this.$store.state.Breadcrumb.paths)
        }
    }
}
</script>
